<template>
  <div class="col-12">
    <Search
      :title="$lang.myPayments"
      :allowFields="$lang.myPaymentsFields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :visibleAdd="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      :defaultViewCount="100"
      removeModalSize="lg"
      :dynamicButtons="dynamicButtons"
      ref="search"
      @getPermisson="updatePermissions"
      @getOther="updateOtherData"
    >
      <template #alerts>
        <div class="mb-2">
          {{ $lang.remaining_total }}:
          <strong class="text-secondary">
            {{ priceFormat(pathOr("", ["remaining_total"], otherData)) }}
            {{ $lang.rial }}
          </strong>
        </div>
      </template>
    </Search>
    <b-modal size="xl" v-model="turnoverModal" hide-footer hide-header>
      <b-row>
        <b-col cols="12">
          <LoadingSpinner :loading="turnoverLoading" />
        </b-col>
        <b-col cols="12" v-if="!turnoverLoading && !turnoverItems.length">
          <b-alert show variant="danger">
            <mdicon name="information" size="24" />
            <span class="ml-2">{{ $lang.notExistParvandehInfoMessage }}</span>
          </b-alert>
        </b-col>
        <b-col
          cols="12"
          class="section"
          v-if="!turnoverLoading && turnoverItems.length"
        >
          <div class="mb-3 font-weight-bold text-muted">
            {{ $lang.view_turnover }}
          </div>
          <b-table-simple
            bordered
            :fields="turnoverFields"
            :items="turnoverItems"
          >
            <b-thead>
              <b-tr>
                <b-th
                  v-for="(headItem, index) in turnoverFields"
                  :key="index"
                  class="p-1 text-center"
                  >{{ headItem.label }}</b-th
                >
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(item, index) in turnoverItems" :key="index">
                <td
                  v-for="(headItem, index) in turnoverFields"
                  :key="index"
                  class="p-1 text-muted text-center font-weight-bold dir_ltr"
                >
                  {{
                    typeof item[headItem.key] === "number"
                      ? priceFormat(item[headItem.key])
                      : item[headItem.key]
                  }}
                </td>
              </b-tr>
              <b-tr class="bg-light">
                <b-td
                  v-for="(key, index) in Object.keys(turnoverTotal)"
                  :key="index"
                  :colspan="!index ? 2 : 1"
                  :class="`p-1 text-center font-weight-bold dir_ltr ${
                    turnoverTotal[key] < 0 ? 'text-danger' : 'text-muted'
                  }`"
                >
                  {{
                    typeof turnoverTotal[key] === "number"
                      ? priceFormat(turnoverTotal[key])
                      : turnoverTotal[key]
                  }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button variant="outline-danger" @click="closeTurnoverModal">
            <mdicon name="close" size="24" />
            {{ $lang.close }}
          </b-button>
          <b-button
            v-if="!turnoverLoading && turnoverItems.length"
            variant="primary"
            class="ml-2"
            @click="print"
          >
            <mdicon name="printer-outline" size="24" />
            {{ $lang.print }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal size="xl" v-model="paymentModal" hide-footer hide-header>
      <b-row>
        <b-col cols="12">
          <Search
            :title="$lang.payment_list_title"
            :allowFields="$lang.myParvandehPaymentFields"
            :hiddenFields="hiddenFields"
            :url="myParvandehPaymentUrl"
            :showAlert="true"
            :titleAlert="myParvandehPaymentTitleAlert"
            colorAlert="info"
            :allowCollapse="false"
            :visibleSearch="true"
            :visibleSettings="true"
            :visibleExport="true"
            :visibleFilters="true"
            :visibleViewCount="true"
            :allowEdit="false"
            :filterCatch="true"
            :showTotals="true"
            :allowOperate="false"
            removeModalSize="lg"
            :visibleAdd="false"
            :otherExportExcelParams="{ parvandeh_code: parvandehCode }"
            @getOther="updateMyParvandehPaymentOtherData"
          />
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button variant="outline-danger" @click="closePaymentModal">
            <mdicon name="close" size="24" />
            {{ $lang.close }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal size="xl" v-model="dailyWorkingModal" hide-footer hide-header>
      <b-row>
        <b-col cols="12">
          <Search
            :title="dailyWorkingTitle"
            :allowFields="$lang.daily_working_allow_fields2"
            :hiddenFields="hiddenFields"
            :url="dailyWorkingUrl"
            :allowCollapse="false"
            :visibleSearch="true"
            :visibleSettings="true"
            :visibleExport="true"
            :visibleFilters="false"
            :showFilterBtn="false"
            :visibleViewCount="true"
            :visibleAdd="false"
            :allowEdit="false"
            :allowOperate="false"
            :filterCatch="false"
            :showTotals="true"
            :openNewTab="true"
            :showCheckBox="false"
            :defaultViewCount="10"
            removeModalSize="lg"
            addModalSize="lg"
            ref="dailyWorkingSearch"
          />
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button variant="outline-danger" @click="closeDailyWorkingModal">
            <mdicon name="close" size="24" />
            {{ $lang.close }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import {
  isAdmin,
  generateApiUrl,
  goToRoute,
  priceFormat,
} from "@/shared/utils";

export default {
  components: { Search, LoadingSpinner },
  data() {
    return {
      dynamicButtons: [
        {
          name: "editView",
          text: this.$lang.view_turnover,
          AllowPermissions: ["admin", "edit", "view"],
          iconFont: {
            name: "credit-card-sync-outline",
            size: "24",
            class: "text-primary",
          },
          click: this.showTurnoverModal,
        },
        {
          name: "editView",
          text: this.$lang.view_turnover_list,
          AllowPermissions: ["admin", "edit", "view"],
          iconFont: {
            name: "badge-account-horizontal-outline",
            size: "24",
            class: "text-success",
          },
          click: this.showPaymentModal,
        },
        {
          name: "editView",
          text: this.$lang.daily_working_list_title,
          AllowPermissions: ["admin", "edit", "view"],
          iconFont: {
            name: "clipboard-list-outline",
            size: "24",
            class: "text-warning",
          },
          click: this.showDailyWorkingModal,
        },
      ],
      permissions: [],
      otherData: null,
      hiddenFields: ["created_by", "created_at.jalali"],
      turnoverModal: false,
      turnoverLoading: false,
      turnoverPerson: "",
      turnoverParvandehNumber: "",
      turnoverItems: [],
      turnoverTotal: null,
      paymentModal: null,
      parvandehCode: null,
      dailyWorkingUrl: null,
      dailyWorkingModal: false,
      dailyWorkingTitle: "",
      myParvandehPaymentUrl: null,
      myParvandehPaymentOtherData: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["cooperation", "myPaymentRuleParvandeh"]);
    },
    turnoverFields() {
      const fields = this.$lang.view_turnover_fields;
      const output = [];
      for (const key of Object.keys(fields)) {
        const obj = { key, label: fields[key] };
        output.push(obj);
      }
      return output;
    },
    myParvandehPaymentTitleAlert() {
      const fullName = pathOr(
        "",
        ["parvandeh", "full_name"],
        this.myParvandehPaymentOtherData
      );
      const parvandehNumber = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        this.myParvandehPaymentOtherData
      );
      return `لیست اسناد پرداخت مربوط به  <strong class='text-primary'>${fullName}</strong> با شماره پرونده <strong class='text-primary'>${parvandehNumber}</strong>`;
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    goToRoute,
    priceFormat,
    getData() {
      this.$refs.search.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = permissions;
    },
    updateOtherData(otherData) {
      this.otherData = otherData;
    },
    goToPayment(item) {
      const parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      goToRoute("search_payment", { parvandehCode }, {}, false);
    },
    print() {
      window.print();
    },
    async showTurnoverModal(item) {
      this.turnoverModal = true;

      try {
        this.turnoverItems = [];
        this.turnoverLoading = true;
        this.turnoverPerson = pathOr(null, ["parvandeh", "full_name"], item);
        this.turnoverParvandehNumber = pathOr(
          null,
          ["parvandeh", "parvandeh_number"],
          item
        );
        const parvandehCode = pathOr(null, ["parvandeh", "code"], item);
        const url = generateApiUrl(
          ["cooperation", "myFinancialReport"],
          [parvandehCode]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.turnoverItems = pathOr([], ["items"], data);
        this.turnoverTotal = pathOr(null, ["total"], data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.turnoverLoading = false;
      }
    },
    closeTurnoverModal() {
      this.turnoverModal = false;
    },
    checkAmount(amount) {
      return amount.replaceAll();
    },
    showPaymentModal(item) {
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      this.myParvandehPaymentUrl = generateApiUrl(
        ["cooperation", "myParvandehPayment"],
        [this.parvandehCode]
      );
      this.paymentModal = true;
    },
    closePaymentModal() {
      this.parvandehCode = null;
      this.paymentModal = false;
    },
    showDailyWorkingModal(item) {
      const parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      const fullName = pathOr(null, ["parvandeh", "full_name"], item);
      this.dailyWorkingTitle = `${this.$lang.daily_working_list_title} <span class="text-primary">${fullName}</span>`;
      this.dailyWorkingUrl = generateApiUrl(
        ["cooperation", "myDailyWorking"],
        [parvandehCode]
      );
      this.dailyWorkingModal = true;
    },
    closeDailyWorkingModal() {
      this.dailyWorkingModal = false;
    },
    updateMyParvandehPaymentOtherData(data) {
      this.myParvandehPaymentOtherData = data;
    },
  },
};
</script>
